export default function useHashCrypt(value, way) {
    if(way) {
        return value + 'bObL$ndVeno%'
      } else {
        return value.substring(0, value.length - 12)
      }
}